import { jsx, jsxs } from "react/jsx-runtime";
import "react";
function SvgDark(props) {
    return /*#__PURE__*/ jsx("svg", {
        viewBox: "0 0 16 14",
        width: 16,
        height: 16,
        ...props,
        children: /*#__PURE__*/ jsxs("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ jsx("path", {
                    fill: "#92B2D2",
                    d: "M14 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 2.4L8 6.9L16 2.5V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0Z"
                }),
                /*#__PURE__*/ jsx("path", {
                    fill: "#3C536A",
                    d: "M7.5 8.9002L0 4.7002V12.0002C0 12.5306 0.210714 13.0393 0.585786 13.4144C0.960859 13.7895 1.46957 14.0002 2 14.0002H14C14.5304 14.0002 15.0391 13.7895 15.4142 13.4144C15.7893 13.0393 16 12.5306 16 12.0002V4.7002L8.5 8.9002C8.3424 8.96944 8.17214 9.00519 8 9.00519C7.82786 9.00519 7.6576 8.96944 7.5 8.9002Z"
                })
            ]
        })
    });
}
const Dark = SvgDark;
export { Dark as default };
